import { __assign, __extends } from "tslib";
import { filter, each, findIndex } from '@antv/util';
import { InteractionAction, TooltipController, registerComponentController, } from '../../../dependents';
// @ts-ignore
var ActiveTooltipController = /** @class */ (function (_super) {
    __extends(ActiveTooltipController, _super);
    function ActiveTooltipController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ActiveTooltipController.prototype, "name", {
        get: function () {
            return 'tooltip-active';
        },
        enumerable: false,
        configurable: true
    });
    ActiveTooltipController.prototype.getTooltipCfg = function () {
        // @ts-ignore
        var cfg = _super.prototype.getTooltipCfg.call(this);
        return __assign(__assign({}, cfg), { showCrosshairs: true, showMarkers: false, shared: true });
    };
    return ActiveTooltipController;
}(TooltipController));
export { ActiveTooltipController };
registerComponentController('tooltip-active', ActiveTooltipController);
var MarkerActiveAction = /** @class */ (function (_super) {
    __extends(MarkerActiveAction, _super);
    function MarkerActiveAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MarkerActiveAction.prototype.init = function () {
        // 移除默认的tooltip交互
        this.getView().removeInteraction('tooltip');
    };
    MarkerActiveAction.prototype.show = function () {
        var curLocation = this.getPoint();
        if (curLocation) {
            this.showTooltip(curLocation);
        }
    };
    MarkerActiveAction.prototype.hide = function () {
        var view = this.getView();
        var controller = this.getTooltipController();
        controller.hideTooltip();
        var points = filter(view.geometries, function (geom) { return geom.type == 'point'; });
        each(points, function (point) {
            each(point.elements, function (element) {
                element.setState('active', false);
            });
        });
    };
    MarkerActiveAction.prototype.showTooltip = function (point) {
        var view = this.getView();
        var controller = this.getTooltipController();
        controller.showTooltip(point);
        var items = controller.getTooltipItems(point);
        var points = filter(view.geometries, function (geom) { return geom.type == 'point'; });
        each(points, function (point) {
            each(point.elements, function (element) {
                element.setState('active', findIndex(items, function (item) { return item.data === element.data; }) !== -1);
            });
        });
    };
    MarkerActiveAction.prototype.getPoint = function () {
        var ev = this.context.event;
        return ev ? { x: ev.x, y: ev.y } : null;
    };
    MarkerActiveAction.prototype.getView = function () {
        return this.context.view;
    };
    MarkerActiveAction.prototype.getTooltipController = function () {
        return this.getView().getController('tooltip-active');
    };
    return MarkerActiveAction;
}(InteractionAction));
export default MarkerActiveAction;
//# sourceMappingURL=marker-active.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/plots/line/interaction/marker-active.js
// module id = null
// module chunks = 